<script lang="ts">
    import type TikTokPostEntity from "@apps/tiktok/entities/TikTokPostEntity";
    import { TikTokUrlUtils } from "@apps/tiktok/utils/TIkTokUrlUtils/TikTokUrlUtils";
    import CN from "classnames";

    import Spinner from "@components/Spinner/Spinner.svelte";

    export let post: TikTokPostEntity;
    let iframeUrl = TikTokUrlUtils.getEmbedIframeUrl(post.postUrl);
    let loaded = false;
    const handleLoad = () => {
        loaded = true;
    };
</script>

<div
    class={CN("gw-tt-embed", {
        "gw-tt-embed--loaded": loaded,
    })}
>
    <div class="gw-tt-embed__spiner">
        <Spinner />
    </div>
    <iframe
        class="gw-tt-embed__iframe"
        name={`__tt_embed__${post.postId}`}
        title={post.title}
        src={iframeUrl}
        on:load={handleLoad}
    />
</div>

<style>
    .gw-tt-embed {
        position: relative;
        width: 323px;
        height: 573px;
        overflow: hidden;
        border: 1px solid #e2e3e4;
        border-radius: 7px;
    }

    .gw-tt-embed__iframe {
        display: none;
        width: calc(100% + 2px);
        min-height: calc(100% + 2px);
        transform: translate(-1px, -1px);
        border: none;
        pointer-events: painted;
    }

    .gw-tt-embed--loaded .gw-tt-embed__iframe {
        display: block;
    }

    .gw-tt-embed__spiner {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        --gw-spinner-color: #d9d9d9;
    }

    .gw-tt-embed--loaded .gw-tt-embed__spiner {
        display: none;
    }
</style>
